/** @jsxImportSource @emotion/react */
import { t } from "i18next";
import { useContext } from "react";
import { CategoryContext } from "../../contexts/CategoryContext";
import useBreakpoint from "../../hooks/useBreakpoint";
import { theme } from "../../theme/theme";
import { CategoryArrayType, MainTopicType } from "../../types/types";
import Box from "../Box/Box";
import Typography from "../Typography/Typography";

type MainTopicCategoryprops = {
  onMouseOver: () => void;
  onMouseOut: () => void;
  categoryByMainTopicArray: CategoryArrayType;
  topic: MainTopicType;
  mainTopicOnOverEffect: MainTopicType | null;
};

const CategoryList = ({
  onMouseOver,
  topic,
  onMouseOut,
  categoryByMainTopicArray,
  mainTopicOnOverEffect,
}: MainTopicCategoryprops) => {
  const { setCategory, setMainTopic } = useContext(CategoryContext);
  const { isDesktop, isFourK } = useBreakpoint();
  return (
    <div
      style={{
        cursor: "pointer",
        width: "50%",
        height: "50%",
        position: "absolute",
        top:
          topic === "reuseCO2" || topic === "reduceMaterials" ? 0 : undefined,
        bottom:
          topic === "reuseMaterials" || topic === "reduceCO2" ? 0 : undefined,
        right:
          topic === "reduceMaterials" || topic === "reduceCO2" ? 0 : undefined,
        left:
          topic === "reuseCO2" || topic === "reuseMaterials" ? 0 : undefined,
        zIndex: 10,
        opacity: mainTopicOnOverEffect === topic ? 1 : 0,
      }}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
    >
      {categoryByMainTopicArray.map((c, idx) => {
        return (
          <Box
            onClick={() => {
              setCategory(c);
              setMainTopic(topic);
            }}
            width={isDesktop || isFourK ? 250 : 220}
            position="absolute"
            top={handleTopPosition(idx, topic)}
            right={handleRightPosition(idx, topic)}
            left={handleLeftPosition(idx, topic)}
            display="flex"
            justifyContent={
              topic === "reuseCO2" || topic === "reuseMaterials"
                ? "flex-end"
                : "flex-start"
            }
            alignItems={idx === 0 ? "center" : "flex-start"}
          >
            {topic === "reduceMaterials" && (
                <div
                  css={{
                    minWidth: idx === 0 ? 30 : 15,
                    minHeight: idx === 0 ? 30 : 15,
                    borderRadius: "50%",
                    backgroundColor: `${theme.colors.secondary}`,
                    marginRight: 12,
                    marginTop: idx === 0 ? 0:  6
                  }}
                />
              )}
              {topic === "reduceCO2" && (
                <div
                  css={{
                    minWidth: idx === 0 ? 30 : 15,
                    minHeight: idx === 0 ? 30 : 15,
                    borderRadius: "50%",
                    backgroundColor: `${theme.colors.primary}`,
                    marginRight: 12,
                    marginTop: idx === 0 ? 0:  6
                  }}
                />
              )}
            <Typography
              variant="body1"
              hoverStyle={{ cursor: "pointer" }}
              style={{
                textAlign:
                  topic === "reuseCO2" || topic === "reuseMaterials"
                    ? "right"
                    : "left",
              }}
            >
              {t(`heidelberg.category.${topic}.${c}.title`)}
            </Typography>
            {topic === "reuseCO2" && (
                  <div
                    css={{
                      minWidth: idx === 0 ? 30 : 15,
                      minHeight: idx === 0 ? 30 : 15,
                      borderRadius: "50%",
                      backgroundColor: `${theme.colors.primary}`,
                      marginLeft: 12,
                      marginTop: idx === 0 ? 0:  6
                    }}
                  />
                )}
                {topic === "reuseMaterials" && (
                  <div
                    css={{
                      minWidth: idx === 0 ? 30 : 15,
                      minHeight: idx === 0 ? 30 : 15,
                      borderRadius: "50%",
                      backgroundColor: `${theme.colors.secondary}`,
                      marginLeft: 12,
                      marginTop: idx === 0 ? 0:  6
                    }}
                  />
                )}{" "}
          </Box>
        );
      })}
    </div>
  );
};

const handleTopPosition = (idx: number, topic: MainTopicType) => {
  switch (topic) {
    case "reuseCO2":
      return idx === 2 ? "20%" : idx === 1 ? "38%" : "60%";
    case "reduceMaterials":
      return idx === 0 ? "20%" : idx === 1 ? "40%" : "65%";
    case "reduceCO2":
      return idx === 0 ? "35%" : idx === 1 ? "55%" : "70%";
    case "reuseMaterials":
      return idx === 2 ? "25%" : idx === 1 ? "50%" : "70%";
  }
};

const handleLeftPosition = (idx: number, topic: MainTopicType) => {
  switch (topic) {
    case "reduceCO2":
      return idx === 0 ? "60%" : idx === 1 ? "50%" : "35%";
    case "reduceMaterials":
      return idx === 0 ? "30%" : idx === 1 ? "50%" : "60%";
  }
  return undefined;
};

const handleRightPosition = (idx: number, topic: MainTopicType) => {
  switch (topic) {
    case "reuseCO2":
      return idx === 2 ? "25%" : idx === 1 ? "45%" : "60%";
    case "reuseMaterials":
      return idx === 2 ? "60%" : idx === 1 ? "50%" : "30%";
  }
  return undefined;
};

export default CategoryList;
